
document.addEventListener('DOMContentLoaded', function() {
  const checkboxes = document.querySelectorAll('.facet-checkbox input[type="checkbox"]');
  
  checkboxes.forEach(checkbox => {
    checkbox.addEventListener('change', function() {
      const parent = checkbox.parentElement;
      if (checkbox.checked) {
        parent.classList.add('selected');
      } else {
        parent.classList.remove('selected');
      }
    });
  });
});

// jQuery(function($) {
//   if ($('#item-detail-info').length) {
//     const itemDetailAccordion = $('.js-item-detail-accordion');
//     itemDetailAccordion.on('click', function () {
//       $(this).addClass('__on');
//     });
//   }
// });


(function($){
  $('.js-accordion-sw').on('click',function(){
    $(this).closest('.js-accordion').toggleClass('open').find('.js-accordion-content').slideToggle(200);
  });
})(jQuery);

// その他のストア
  $(function () {
      $('.item-detail_mall-banners a').attr({ 'target': '_blank' });
    });
    
// 商品ページ ページ上部へ戻る
 $(function () {
    var baloon_pos_fix = ($('.smoothscroll-top').length) ? true : false;
    $(window).scroll(function () {
      if ($(this).scrollTop() > 1000) { 
        if(baloon_pos_fix){
           $('#coupon-baloon-switch').addClass('__on'); 
          $('.fixed_bnr').addClass('__on');
        }
        $('.smoothscroll-top').fadeIn();
      } else {
        if(baloon_pos_fix){
           $('#coupon-baloon-switch').removeClass('__on'); 
          $('.fixed_bnr').removeClass('__on'); 
        }
        $('.smoothscroll-top').fadeOut();
      }
    });

    $('.smoothscroll-top').click(function () {
      var speed = 300;
      $("html, body").animate({ scrollTop: 0 }, speed, "swing");
      return false;
    });
  });
  
// shopifyクーポンバルーン
    if($("#coupon-baloon").length){
    $('#coupon-baloon-switch').fadeIn(100);
    $('#coupon-baloon-switch,#coupon-button-switch').on('click',function(){
      $('.coupon-baloon-content_detail').removeClass('__copied __disabled');
      $('#coupon-baloon').fadeIn(50);
    });
    $('.js-coupon-baloon-close').on('click',function(){
      $('#coupon-baloon').fadeOut(50,()=>{
        //$('.coupon-baloon-content_detail').removeClass('__copied __disabled');
      });
    });
  }
  if($(".js-coupon-copy").length){
    $('.js-coupon-copy').on('click',function(){
      const current_coupon = $(this).closest('.coupon-baloon-content_detail');
      if (navigator.clipboard) {
        const code = $(this).find(".coupon-baloon-content_code-value").val();
        navigator.clipboard.writeText(code).then(function () {
          current_coupon.addClass('__copied');
          $('.coupon-baloon-content_detail').not('.__copied').addClass('__disabled');
        });
      } else {
        $(this).find(".coupon-baloon-content_code-value").select();
        document.execCommand('copy');
        current_coupon.addClass('__copied');
        $('.coupon-baloon-content_detail').not('.__copied').addClass('__disabled');
      }
    });
  } 
